module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAAA9UlEQVRIDb2WYQ6CMAyFF38K5+HQavBEcpX5nq6kNGOs09Gkbgj93tY9gyHGOCFfyCdyCD8GGYlF5hTwsSAl7pg0i7AWSYbEQoFZrtLIB0bvRliD1HDiZgrwxo1XKlwiqMvByfwuFJMB2SRSgG9b3SJSDZd+e0TccCVyeCYFeJ05EiB3JlfcY1q38Nk6uNmJBT0AYupwOU74nxGUnP3+Axcl0Ghhu2qK8LutFaVIjRc1P3+KFfZr0Q6cbbHt8h9ygvexaQG++nxnd8e/BRTSMbmVr3BxQkEk7ywP3C3SAq8WSVutaotA7Vho13jKK7P7S7/r35Y3+XX7gpVXPZQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close-icon.png
// module id = kbsO
// module chunks = 1